import { Box, Button } from "@chakra-ui/react"
import { AbstractConnector } from "@web3-react/abstract-connector"
import { useWeb3React } from "@web3-react/core"
import React, { useCallback } from "react"

import { WalletType } from "../constant"
import { Account } from "../container/account"
import { Checkmark, CoinbaseWallet, Metamask, TorusConnect, WalletConnect } from "../dependency"
import { activateInjectedProvider } from "../utils"

const LeftIconMap = {
    [WalletType.METAMASK]: <Metamask boxSize="24px" />,
    [WalletType.WALLET_CONNECT]: <WalletConnect boxSize="24px" />,
    [WalletType.WALLETLINK_CONNECT]: <CoinbaseWallet boxSize="24px" borderRadius="full" />,
    [WalletType.TORUS_CONNECT]: <TorusConnect boxSize="24px" borderRadius="full" />,
}

export function WalletButton({
    type,
    name,
    connector,
}: {
    type: WalletType
    name: string
    connector: AbstractConnector
}) {
    const {
        actions: { login },
    } = Account.useContainer()
    const { connector: activeConnector } = useWeb3React()

    const isActiveConnector = activeConnector === connector

    const handleOnClick = useCallback(async () => {
        if (!isActiveConnector) {
            if (type === WalletType.TORUS_CONNECT || type === WalletType.WALLET_CONNECT) {
                await login(connector, type)
            } else {
                // NOTE: prevent trigger both coinbase wallet and metamask in the same time
                // https://github.com/NoahZinsmeister/web3-react/issues/300
                activateInjectedProvider(type)
                await login(connector, type)
            }
        }
    }, [connector, login, type, isActiveConnector])

    return (
        <Button
            iconSpacing={4}
            isFullWidth
            leftIcon={LeftIconMap[type]}
            rightIcon={<Checkmark boxSize="20px" opacity={isActiveConnector ? 1 : 0} />}
            onClick={handleOnClick}
        >
            <Box flexGrow={1} textAlign="left">
                {name}
            </Box>
        </Button>
    )
}
